module.exports = __webpack_public_path__ + "static/media/room-feature-beds.b8d0bfa5.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/room-feature-beds.svg
// module id = 563
// module chunks = 9